<script setup>
import { giftingItemsMenu, occasionsMenu } from '#wa/utils/metadata'
import stockMenus from './menus.json'

const metadata = useMetadata()

const menus = computed(() => {
  const menus = _.cloneDeep(stockMenus)
  // Add the Occasions to the menu
  menus.items.splice(
    1,
    0,
    occasionsMenu(metadata.occasions, metadata.constance.EP1_ENABLE === 'True'),
  )
  // Add gifting items to the menu
  menus.items.forEach((itemsMenu) => {
    if (itemsMenu.text === 'Gifting') {
      itemsMenu.items.push(...giftingItemsMenu(metadata.gifting_menu_items))
    }
  })
  return menus
})
</script>

<template>
  <div class="site-navigation">
    <nav id="site-navigation" aria-label="Main Menu">
      <DesktopMenu :menu="menus" />
    </nav>
  </div>
</template>
